import { VTSHistoryModel } from './../models/vtshistory.model';
import { VTSHistoryService } from './../models/vtshistory.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-VTSHistory',
  template: require('../views/vtshistory-list.component.html'),
  providers: [VTSHistoryService],
})
export class VTSHistoryListComponent implements OnInit {
  DataListModel: DataListModel;
  vtsHistoryList: VTSHistoryModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  sub: any;
  vehicleMasterHashId: string;
  urlVtsTroubleShootPage: string;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  @ViewChild('successPopup') public successPopup: any;

  constructor(private vtsHistoryService: VTSHistoryService,
    private translate: TranslateService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblEventHistory');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["licenceTag", "requestType", "result", "commandInitiator"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlVtsTroubleShootPage = this.authService.GetURL(ApplicationRouteURL.URL_VTS_TROUBLESHOOT);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.vehicleMasterHashId = params['vehicleMasterHashId'] || '';
        if (this.vehicleMasterHashId != '') {
          this.GetVTSHistoryList();
        }
      });
  }

  public GetVTSHistoryList() {
    this.isLoading = true;
    this.vtsHistoryService.GetVTSHistoryList(this.DataListModel, this.vehicleMasterHashId)
      .subscribe(
      (res: any) => {
        this.vtsHistoryList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVTSHistoryList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVTSHistoryList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetVTSHistoryList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVTSHistoryList();
  };

  public OnExport(event: any) {
    this.isLoading = true;
    this.vtsHistoryService.ExportVTSHistoryList(this.DataListModel,this.vehicleMasterHashId)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "VTSHistory" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vtshistory/components/vtshistory-list.component.ts